import { useTranslation } from 'react-i18next'
import CommunicationBoardContent from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/CommunicationBoardContent'
import { selectCommunicationBoardState } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { useSelector } from 'react-redux'
import useCommunicationBoardData from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/useCommunicationBoardData'
import useCommunicationBoardEventListener from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/useCommunicationBoardEventListener'

const CommunicationBoard = () => {
  const { t } = useTranslation()
  const { sections, error } = useSelector(selectCommunicationBoardState)
  useCommunicationBoardEventListener()
  const { visibleSections } = useCommunicationBoardData()

  return <CommunicationBoardContent t={t} visibleSections={visibleSections} sections={sections} error={error} />
}

export default CommunicationBoard
